var React = require('react');

function CheckCircleColor (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"24/check-circle"},React.createElement("path",{"id":"Vector","d":"M7.99992 14.6673C4.31792 14.6673 1.33325 11.6827 1.33325 8.00065C1.33325 4.31865 4.31792 1.33398 7.99992 1.33398C11.6819 1.33398 14.6666 4.31865 14.6666 8.00065C14.6666 11.6827 11.6819 14.6673 7.99992 14.6673ZM6.89592 11.0007L11.8953 6.00065L10.9526 5.05798L6.89592 9.11532L5.00992 7.22932L4.06725 8.17198L6.89592 11.0007Z","fill":"#45BA7B"})));
}

CheckCircleColor.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = CheckCircleColor;

CheckCircleColor.default = CheckCircleColor;
